import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { loginInfoDispatcher } from "../../actions/authenticationAction";
import {
  clearSession,
  userLogin,
  updatePassword,
  checkRegistrationAllowed
} from "../api/authenticationApi";
import moment from "moment";
import { studentSignup, studentLogin, getStudentRestriction, onClickEdit } from '../api/admissionApi';
import TextField from "@mui/material/TextField";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAllSubjects } from "../api/dashboardApi";
import Header from "../common/Header";
import Spinner from "../common/Spinner";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userID: "",
      password: "",
      emailEmpty: false,
      passwordEmpty: false,
      displayFailureMessage: true,
      currentPassword: "",
      newPassword: "",
      reNewPassword: "",
      loginType: "faculty",
      isRegister: false,
      studentSignup: {
        registration_for_course: "",
        date_of_birth: "",
        full_name: {
          first_name: "",
        },
        mobile_number: "",
        email_id: "",
        isDisabled: true
      },
      showSpinner: false
    };
  }

  componentDidMount() {
    const { faculty_id = "", dispatch, history } = this.props;
    if (history) history.push("/login");
    this.setState({ 
      userID: faculty_id
    });
    clearSession(dispatch);
  }

  setNewStudentSignupDetails = (fieldName, e) => {
    const studentDetails = { ...this.state.studentSignup };

    if (fieldName === "first_name") {
      studentDetails.full_name.first_name = e.target.value;
    }
    if (fieldName === "registration_for_course") {
      studentDetails.registration_for_course = e.target.value;
    }
    if (fieldName === "mobile_number") {
      studentDetails.mobile_number = e.target.value;
    }
    if (fieldName === "email_id") {
      studentDetails.email_id = e.target.value;
    }
    if (fieldName === "date_of_birth") {
      studentDetails.date_of_birth = e.target.value;
    }

    const disabled = !studentDetails.full_name.first_name || !studentDetails.date_of_birth || !studentDetails.email_id ||
      !studentDetails.mobile_number || !studentDetails.registration_for_course || studentDetails.registration_for_course === 'select';

    studentDetails.isDisabled = disabled;

    this.setState({ studentSignup: studentDetails });
  };

  postStudentSignup = () => {
    const { studentSignup } = this.props;
    const callback = {
      errorCallback: this.signupErrorCallback,
      successCallback: this.signupSuccessCallback
    }
    studentSignup(this.state.studentSignup, callback);
  };

  signupErrorCallback = (msg = '') => {
    toast.error(msg, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
  }

  signupSuccessCallback = () => {
    const resetState = {
      registration_for_course: "",
      date_of_birth: "",
      full_name: {
        first_name: "",
      },
      mobile_number: "",
      email_id: "",
      isDisabled: true
    }
    this.setState({ studentSignup: resetState });
    toast.success("Account creation successful. We have sent your password to your registered Email Id.", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined
    });
    this.setCandidateRegister();
  };

  setCandidateRegister = () => {
    this.setState({showSpinner: false});
    const registerInfo = {
      registration_for_course: "",
      date_of_birth: "",
      full_name: {
        first_name: "",
      },
      mobile_number: "",
      email_id: "",
      isDisabled: true
    };
    this.setState({ isRegister: !this.state.isRegister, studentSignup: registerInfo });
  };

  registerNewStudent = () => {
    this.setState({showSpinner: true});
    const {checkRegistrationAllowed} = this.props;
    const payload = {
      year: moment(new Date()).format("YYYY")
    };
    const callbacks = {
      successCallback: this.setCandidateRegister,
      failureCallback: this.restrictStudentFailure
    };
    checkRegistrationAllowed(payload, callbacks);
  }

  setLoginType = (type) => {
    this.setState({ loginType: type, userID: "", password: "" });
    this.setState({ emailEmpty: false, passwordEmpty: false });

  };

  setCredentials = (fieldName, e) => {
    if (fieldName === "userID") {
      this.setState({ userID: e.target.value, emailEmpty: false });
    } else if (fieldName === "password") {
      this.setState({ password: e.target.value, passwordEmpty: false });
      if (e.keyCode === 13) {
        if (this.state.loginType === 'student') {
          this.postStudentLogin();
        } else {
          this.postUserLogin();
        }
      }
    }
  };

  postUserLogin = () => {
    const { dispatch, history } = this.props;
    const { userID, password, loginType } = this.state;
    this.setState({ emailEmpty: !userID, passwordEmpty: !password });
    const navigateTo = () => {
      if (history) history.push("/");
    };
    if (userID && password) {
      const payload = {
        faculty_id: userID,
        password: password,
        loginType,
      };
      userLogin(payload, dispatch, navigateTo, this.userLoginFailureCallback);
    }
  };

  postStudentLogin = () => {
    const { studentLogin } = this.props;
    const { history, login_restricted, getStudentRestriction } = this.props;
    const { userID, password } = this.state;
    this.setState({ emailEmpty: !userID, passwordEmpty: !password });
    const navigateTo = () => {
      if (history) history.push("/");
    };
    if (userID && password && !login_restricted) {
      const payload = {
        email_id: userID,
        password: password
      };
      studentLogin(payload, navigateTo, this.userLoginFailureCallback);
    } else if (userID) {
      const payload = {
        email_id: userID
      };
      const callback = {
        failureCallback: this.restrictStudentFailure,
        successCallback: this.restrictStudentSuccess
      }
      getStudentRestriction(payload, callback);
    }
  }

  restrictStudentFailure = (err = '') => {
    this.setState({showSpinner: false});
    toast.error(err, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    })
  }

  restrictStudentSuccess = () => {
    toast.error('Your account login is restricted by college. Please contact admin.', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    })
  }

  updateAcPassword = () => {
    const { currentPassword, newPassword, reNewPassword } = this.state;
    const { faculty_id = '', updateAccountPassword } = this.props;
    const sameCurr = currentPassword === newPassword;
    const diffNew = newPassword !== reNewPassword;
    const isNotDefault = currentPassword !== "password";
    if (sameCurr || diffNew || isNotDefault) {
      let displayText = "";
      if (sameCurr) {
        displayText = "Current password and New password can not be same";
      } else if (diffNew) {
        displayText = "New password and re-entered password are not same";
      } else if (isNotDefault) {
        displayText = "Current password is not correct";
      }
      toast.warn(displayText, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    } else {
      const payload = {
        faculty_id: faculty_id,
        password: currentPassword,
        updatedPassword: newPassword
      };
      const callbacks = {
        updateSuccessCallback: this.updateSuccess,
        updateFailureCallback: this.updateFailure,
      };
      updateAccountPassword(payload, callbacks);
    }
  };

  updateSuccess = () => {
    const { history } = this.props;
    toast.success(
      "Password updated successfully. Redirecting to dashboard...",
      {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        onClose: () => history.push("/"),
      }
    );
  };

  updateFailure = () => {
    toast.error("Error occured. Please try again...", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
  };

  userLoginFailureCallback = () => {
    this.setState({ displayFailureMessage: true });
    setTimeout(() => {
      this.setState({ displayFailureMessage: false });
    }, 4000);
  };

  renderFailureNotification = () => {
    const { apiCalled, studentLoginCalled } = this.props;

    return (
      <div
        className={`notification-bar ${(apiCalled || studentLoginCalled) && this.state.displayFailureMessage ? "active" : ""
          }`}
      ></div>
    );
  };

  navigateToRegistrationForm = async () => {
    const { getAllSubjects, history } = this.props;
    const isSuccess = await getAllSubjects();

    if (isSuccess) {
      history.push("/studentRegistration");
    } else {
      toast.error("Error occured. Please try again...", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    }
  };

  renderLoginComponent = () => {
    const { emailEmpty, passwordEmpty, loginType } = this.state;
    const { isLoading, isStudentLoading, login_restricted, restrictionLoading, restrictionAPICalled, onClickEdit } = this.props;
    const show = loginType === 'faculty' ? true : !login_restricted;
    const emailDisabled = loginType === 'student' && !login_restricted && restrictionAPICalled;
    
    return (
      <Fragment>
        {this.renderFailureNotification()}
        <div className="card-body">
          <div className="text-center">
            <div className="header-brand">
              <img
                alt="logo"
                src="./assets/logo (1).png"
                width="70px"
                className="mb-3"
              />
            </div>
            <div className="mb-2">Login to your account</div>
            <div
              className="text-primary mb-2"
              style={{ textTransform: "capitalize" }}
            >{`${this.state.loginType} login`}</div>
          </div>
          <div className={`form-group d-flex align-items-center ${emailDisabled ? 'hover-class' : ''}`} style={{marginBottom: "0rem"}}>
            <input
              type="email"
              className={`form-control ${emailEmpty ? "error" : ""}`}
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Enter Login ID"
              value={this.state.userID}
              onChange={(e) => this.setCredentials("userID", e)}
              disabled={emailDisabled}
            />
            {emailDisabled && <i className="fa fa-pencil pencil-class" aria-hidden="true" onClick={onClickEdit}></i>}
          </div>
          <div style={{marginBottom: "1rem", fontSize: "small"}}>Example: 1</div>
          {show && (
            <>
              <div className="form-group">
                <input
                  type="password"
                  className={`form-control ${passwordEmpty ? "error" : ""}`}
                  id="exampleInputPassword1"
                  placeholder="Enter Password"
                  onChange={(e) => this.setCredentials("password", e)}
                  onKeyUp={(e) => this.setCredentials("password", e)}
                />
                <div style={{fontSize: "small"}}>Example: Test@1234</div>
              </div>
              <div className="form-group">
                <label className="custom-control custom-checkbox">
                  <input type="checkbox" className="custom-control-input" />
                  <span className="custom-control-label">Remember me</span>
                </label>
              </div>
            </>
          )}
          <div className="text-center">
            <div
              className={`btn btn-primary btn-block login-btn ${(isLoading || isStudentLoading) ? "loading" : ""
                }`}
              onClick={loginType === 'student' ? this.postStudentLogin : this.postUserLogin}
            >
              {(isLoading || isStudentLoading || restrictionLoading) ? (
                <i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
              ) : (
                show ? "Sign in" : "Continue"
              )}
            </div>
          </div>
          {loginType === "student" && (
            <div
              className="text-center mt-2"
              onClick={this.registerNewStudent}
            >
              New Candidate?{" "}
              <span className="link" style={{ textDecoration: "underline" }}>
                Register
              </span>
            </div>
          )}
        </div>
      </Fragment>
    );
  };

  renderUpdatePasswordSection = () => {
    const { passwordUpdating, passwordResetSuccess } = this.props;
    return (
      <div className="card-body">
        <div className="text-center">
          <div className="header-brand">
            <i className="fa fa-graduation-cap brand-logo"></i>
          </div>
          <div className="mt-3">This is your first Login...</div>
          <div className="mt-1 mb-4">Please update your account password</div>
        </div>
        <div className="form-group">
          <TextField
            id="outlined-password-input"
            label="Current Password"
            type="password"
            size="small"
            fullWidth
            value={this.state.currentPassword}
            onChange={(e) => this.setState({ currentPassword: e.target.value })}
          />
        </div>
        <div className="form-group">
          <TextField
            id="outlined-password-input"
            label="Enter new Password"
            type="password"
            size="small"
            fullWidth
            value={this.state.newPassword}
            onChange={(e) => this.setState({ newPassword: e.target.value })}
          />
        </div>
        <div className="form-group">
          <TextField
            id="outlined-password-input"
            label="Re-enter new Password"
            type="password"
            size="small"
            fullWidth
            value={this.state.reNewPassword}
            onChange={(e) => this.setState({ reNewPassword: e.target.value })}
            onKeyUp={(e) => {
              e.keyCode === 13 && this.updateAcPassword();
            }}
          />
        </div>
        <div className="text-center">
          <div
            className={`btn btn-primary btn-block login-btn ${passwordUpdating || passwordResetSuccess ? "loading" : ""
              }`}
            onClick={this.updateAcPassword}
          >
            {passwordUpdating || passwordResetSuccess ? (
              <i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
            ) : (
              "Update Password"
            )}
          </div>
        </div>
      </div>
    );
  };

  newCandidateSection = () => {
    const { signupLoading } = this.props;
    return (
      <Fragment>
        <div className="card-body">
          <div className="text-center">
            <div className="header-brand">
              <img
                alt="logo"
                src="./assets/logo (1).png"
                width="70px"
                className="mb-3"
              />
            </div>
            <div className="mb-2">New Candidate Account</div>
          </div>
          <div className="form-group">
            <input
              type="text"
              className={`form-control`}
              placeholder="Enter first name"
              defaultValue={this.state.studentSignup.full_name.first_name}
              onChange={(e) => this.setNewStudentSignupDetails("first_name", e)}
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              className={`form-control`}
              aria-describedby="emailHelp"
              placeholder="Enter Email"
              defaultValue={this.state.studentSignup.email_id}
              onChange={(e) => this.setNewStudentSignupDetails("email_id", e)}
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              maxLength="10"
              className={`form-control`}
              placeholder="Enter Mobile number"
              max={10}
              defaultValue={this.state.studentSignup.mobile_number}
              onChange={(e) =>
                this.setNewStudentSignupDetails("mobile_number", e)
              }
            />
          </div>
          <div className="form-group">
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text">DOB</span>
              </div>
              <input type="date" className="form-control" onChange={(e) => this.setNewStudentSignupDetails("date_of_birth", e)} />
            </div>
          </div>
          <div className="form-group">
            <select
              name="cars"
              id="cars"
              className="form-control"
              value={this.state.studentSignup.registration_for_course}
              onChange={(e) =>
                this.setNewStudentSignupDetails("registration_for_course", e)
              }
            >
              <option value="select">Select Course Type</option>
              <option value="Bachelors">UG</option>
              <option value="Masters">PG</option>
            </select>
          </div>
          <div className="text-center">
            <button
              className={`btn btn-primary btn-block login-btn`}
              onClick={this.postStudentSignup}
              disabled={this.state.studentSignup.isDisabled || signupLoading}
            >
              {signupLoading ? <i className="fa fa-circle-o-notch fa-spin fa-fw"></i> : 'Create Account'}
            </button>
          </div>
        </div>
      </Fragment>
    );
  };

  renderHeader = () => {
    const { isRegister, loginType } = this.state;
    const { isLoginSuccess } = this.props;
    if (isRegister) {
      return (
        <div
          className="d-flex card glass text-center p-2"
          style={{ borderBottom: "none", height: "3rem" }}
          onClick={this.setCandidateRegister}
        >
          <span className="link">
            <i className="fa fa-long-arrow-left mr-2" aria-hidden="true"></i>
            Back to Login
          </span>
        </div>
      );
    }

    return (
      <div
        className="d-flex card glass"
        style={{
          flexDirection: "row",
          borderRadius: "20px 20px 0px 0px",
          borderBottom: "none",
        }}
      >
        <div
          className={`child-0 p-2 ${loginType === "faculty" ? "active" : ""}`}
          onClick={() => this.setLoginType("faculty")}
        >
          Faculty Login
        </div>
        <div
          className={`child-1 p-2 ${loginType === "student" ? "active" : ""} ${isLoginSuccess && loginType === "faculty" ? 'disabled' : ''}`}
          onClick={() => this.setLoginType("student")}
          disabled
        >
          Student Login
        </div>
      </div>
    );
  };

  render() {
    const { isLoginSuccess, fetchingSubjects = false } = this.props;
    const { isRegister, showSpinner } = this.state;

    return (
      <div className="auth option2">
        <Header
          navigateToRegistrationForm={this.navigateToRegistrationForm}
          loginType={this.state.loginType}
          setLoginType={this.setLoginType}
        />
        <div className="auth_left" style={{ placeContent: "center" }}>
          <div
            id="form-container"
            className=""
            style={{
              width: "fit-content",
              height: "27rem",
            }}
          >
            {this.renderHeader()}
            {!isRegister ? (
              <div
                className={`card glass ${this.state.loginType}`}
                style={{ width: "18rem", top: "-24px", borderTop: "none" }}
              >
                {!isLoginSuccess
                  ? this.renderLoginComponent()
                  : this.renderUpdatePasswordSection()}
              </div>
            ) : (
              <div
                className="card glass"
                style={{ width: "18rem", top: "-24px" }}
              >
                {this.newCandidateSection()}
              </div>
            )}
          </div>
        </div>
        <ToastContainer />
        {(fetchingSubjects || showSpinner) && <Spinner />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  faculty_id: state.authenticationReducer.faculty_id,
  isLoading: state.authenticationReducer.isLoading,
  isLoginSuccess: state.authenticationReducer.login,
  apiCalled: state.authenticationReducer.apiCalled,
  isDefaultPassword: state.authenticationReducer.isDefaultPassword,
  userId: state.authenticationReducer._id,
  passwordUpdating: state.authenticationReducer.passwordUpdating,
  passwordResetSuccess: state.authenticationReducer.passwordResetSuccess,
  fetchingSubjects: state.dashboardReducer.fetchingSubjects,
  signupLoading: state.admissionReducer.isLoading,
  isStudentLoading: state.admissionReducer.isStudentLoading,
  studentLoginCalled: state.admissionReducer.studentLoginCalled,
  login_restricted: state.admissionReducer.login_restricted,
  restrictionLoading: state.admissionReducer.restrictionLoading,
  restrictionAPICalled: state.admissionReducer.restrictionAPICalled
});

const mapDispatchToProps = (dispatch) => ({
  loginInfoDispatcher: (e) => dispatch(loginInfoDispatcher(e)),
  updateAccountPassword: (e, cb) => dispatch(updatePassword(e, cb)),
  getAllSubjects: () => dispatch(getAllSubjects()),
  studentSignup: (e, cb) => dispatch(studentSignup(e, cb)),
  studentLogin: (e, nvt, cb) => dispatch(studentLogin(e, nvt, cb)),
  getStudentRestriction: (e, cb) => dispatch(getStudentRestriction(e, cb)),
  onClickEdit: () => dispatch(onClickEdit()),
  checkRegistrationAllowed: (e, cb) => dispatch(checkRegistrationAllowed(e, cb)),
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(Login);
